import { useCallback, useRef, useState } from 'react';
import { WorkflowTab } from '@/app/workflows/utils/navigation';
import { useWorkflowsQuery } from '@/app/workflows/components/table/query/useWorkflowsQuery';

export const useWorkflows = () => {
  const [workflowTab, setWorkflowTab] = useState<WorkflowTab>(WorkflowTab.ALL);
  const [searchTerm, setSearchTerm] = useState<string | undefined>(undefined);
  const [searchUserInput, setSearchUserInput] = useState<string>('');
  const { data: workflows, error } = useWorkflowsQuery({}, workflowTab, searchTerm);

  return {
    workflows,
    error,
    workflowTab,
    setWorkflowTab,
    setSearchTerm,
    searchUserInput,
    setSearchUserInput,
  };
};

export const useScrollToTop = () => {
  const viewport = useRef<HTMLDivElement>(null);
  const scrollToTop = useCallback(() => {
    viewport.current?.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return { viewport, scrollToTop };
};
